import * as React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, LinearProgress, Switch, useMediaQuery, useTheme } from '@mui/material';
import { AlumnoType } from '../../types/types';
import { useContext, useState } from 'react';
import { UserContext } from '../../contexts/userContext';
import { UseGetHnos } from '../../hooks/hermanos';
import DeudaReportFamiliar from './DeudaReportFamiliar';
import DeudaReport from './DeudaReport';


export interface DateReportProps {
  alumno: AlumnoType | null;
  onClose: () => void;
  refetchLista: () => void;
  verHistorico: boolean;
}

export default function DeudaReportDialog(props: DateReportProps) {
  const { alumno, onClose, refetchLista, verHistorico } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const { user } = useContext(UserContext);
  const [verDeudaFamiliar, setVerDeudaFamiliar] = useState(false);
  const hermanos = UseGetHnos(alumno?._id, user);

  if (!alumno) return null;
  if (!user?._id) return null;
  if (!hermanos.data) return <LinearProgress />;


  return (
    <Box id="dialog-BOX" style={{ height: '70vh' }}>
      <Dialog open onClose={onClose} fullWidth maxWidth={false} fullScreen={isMobile}>
        <DialogTitle>
          {`Reporte de deuda de ${alumno.name} ${alumno.apellido}`}
        </DialogTitle>
        <DialogContent  style={{ padding: isMobile ? 0 : 16 }}>
          {verDeudaFamiliar ?
            <DeudaReportFamiliar
              alumno={alumno}
              refetchLista={refetchLista}
              verHistorico={verHistorico}
            /> :
            <DeudaReport
              alumno={alumno}
              refetchLista={refetchLista}
              verHistorico={verHistorico}
            />
          }
        </DialogContent>
        <DialogActions>
          {hermanos.data?.length > 1 && !isMobile && <FormControlLabel
            control={<Switch
              color="default"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setVerDeudaFamiliar(event.target.checked);
              }}
            />}
            checked={verDeudaFamiliar}
            label="Pago Familiar"
          />}
          <Button
            variant="contained"
            onClick={onClose}
          >
               Salir
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
